import { useQuery } from '@tanstack/react-query';
// api
import { dashboardApi } from '@/domains/traffic-monitoring/apis/dashboard';
// constant
import { DASHBOARD_CONSTANTS } from '@/domains/traffic-monitoring/constants/dashboard.constants';
import type { VehicleInOutCountParams } from '../types/dashboard.types';

export interface InOutDirection {
  volume: number;
  speed: number; // km/h; 0 when no samples
}

// PSC_PC0203001_BE_004 - area-wide by default (omit cctv_id). Returns incoming /
// outgoing volume and the day's average speed per direction. `direction_field`
// selects the direction keyword to count.
export const useVehicleInOut = (params: VehicleInOutCountParams = {}) => {
  const { data, isLoading, isError } = useQuery({
    queryKey: ['vehicleInOutCount', params],
    queryFn: () => dashboardApi.getVehicleInOutCount(params),
    staleTime: DASHBOARD_CONSTANTS.CROSSROAD_DASHBOARD.STALE_TIME_MS,
    gcTime: DASHBOARD_CONSTANTS.CROSSROAD_DASHBOARD.CACHE_TIME_MS,
    refetchInterval: DASHBOARD_CONSTANTS.CROSSROAD_DASHBOARD.REFETCH_INTERVAL_MS,
    placeholderData: (prev) => prev,
  });

  const d = data?.data;
  const incoming: InOutDirection = {
    volume: d?.incoming_count ?? 0,
    speed: d?.incoming_avg_speed ?? 0,
  };
  const outgoing: InOutDirection = {
    volume: d?.outgoing_count ?? 0,
    speed: d?.outgoing_avg_speed ?? 0,
  };

  return { incoming, outgoing, totalCount: d?.total_count ?? 0, isLoading, isError };
};
